document.addEventListener("DOMContentLoaded", function() {
    let last_rowElem = document.querySelector('#loading_next');
    let in_viewport = false;
        window.onscroll = function() {
        in_viewport = isInViewport(last_rowElem);
        if (in_viewport && window.infinite_scroll_firstTime) {
            window.infinite_scroll_firstTime = false;
            var endlessScroll = new Ajaxinate({
                container: '#product-grid',
                pagination: '#loading_next',
                callback: function() {
                    // After new products are loaded, trigger review updates
                    document.dispatchEvent(new Event('filter:update'));
                }
            });
        }
    }

// Determine if an element is in the visible viewport
    function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    }

})
